import { render, staticRenderFns } from "./Questionaire.vue?vue&type=template&id=50d795fc"
import script from "./Questionaire.vue?vue&type=script&lang=js"
export * from "./Questionaire.vue?vue&type=script&lang=js"
import style0 from "./Questionaire.vue?vue&type=style&index=0&id=50d795fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports